import { render, staticRenderFns } from "./TaskDriverSingle.vue?vue&type=template&id=ae2f66ec&scoped=true&"
import script from "./TaskDriverSingle.vue?vue&type=script&lang=js&"
export * from "./TaskDriverSingle.vue?vue&type=script&lang=js&"
import style0 from "./TaskDriverSingle.vue?vue&type=style&index=0&id=ae2f66ec&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae2f66ec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAvatar,VIcon,VTooltip})
